module.exports = __webpack_public_path__ + "img/Account.2b8e51f2.svg";